import React from 'react';
import { Layout } from 'antd';
import SiteSpeed from '../SiteSpeed';
import WebsiteIndexEntryTabs from '../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs';


export default function SiteSpeedPage() {
    return (
        <Layout.Content className="general-layout-content">
            <WebsiteIndexEntryTabs>
                <SiteSpeed />
            </WebsiteIndexEntryTabs>
        </Layout.Content>
    );
}
